module.exports = __webpack_public_path__ + "static/media/pricing-pattern.a7f1cc3f.svg";